import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
const useLanguagePack = function (moduleName) {
  let {
    locale: givenLocale
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const dispatch = useDispatch();
  const locale = useSelector(state => givenLocale || state.getIn(['intl', 'activeLocale']));
  const langPackState = useSelector(state => state.getIn(['intl', 'languagePacks', locale, moduleName]));
  const isLoading = langPackState === null || langPackState === void 0 ? void 0 : langPackState.get('isLoading');
  // only set to false after success/fail
  const isLoaded = isLoading === false;
  const error = langPackState === null || langPackState === void 0 ? void 0 : langPackState.get('error');
  const data = useMemo(() => langPackState === null || langPackState === void 0 ? void 0 : langPackState.get('data'), [langPackState]);
  useEffect(() => {
    // prevent call if mid loading or loaded
    if (!isLoading && !isLoaded) {
      dispatch(loadLanguagePack(moduleName, {
        locale
      }));
    }
  }, [isLoading, isLoaded, dispatch, moduleName, locale]);
  return useMemo(() => ({
    isLoading: !isLoaded,
    // report loading if not loaded
    data: isLoaded && !error ? data.toJS() : undefined,
    error
  }), [isLoaded, data, error]);
};
export default useLanguagePack;